var render, staticRenderFns
import script from "./Deposit.vue?vue&type=script&lang=js"
export * from "./Deposit.vue?vue&type=script&lang=js"
import style0 from "./Deposit.vue?vue&type=style&index=0&id=43e0c980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e0c980",
  null
  
)

export default component.exports